module.exports = __webpack_public_path__ + "media/images/dashboard/weather-card-b63bb47d2a4a79cbe65244f08bf35fe6.jpg";